// components/Modal.jsx
import React from "react";
import "../style/Modal.css";

export default function Modal({ children, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-campaignlist" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-campaign" onClick={onClose}>✖</button>
        {children}
      </div>
    </div>
  );
}
